import { useMutation } from '@tanstack/react-query';
import { signInUser } from '../services/api';

interface SignInUserParams {
    email: string;
    password: string;
}

export function useSignInUser() {
    return useMutation({
        mutationFn: async (params: SignInUserParams) => {
            const response = await signInUser(params);

            // Don't throw errors - return the response as-is
            // The component will check for success/error
            return response;
        },
        // Don't use error boundaries, let components handle errors
        throwOnError: false,
        // Add retry: false to prevent React Query from retrying expected errors
        retry: false,
    });
}
